<template>
  <div v-show="agent.id" class="ut-container-lg" v-cloak>
    <article>

      <div v-show="hasCRMIntegration && !crmReconnectionRequired" class="thank-you-section">
          <div class="page-heading">
              <h1>Thanks</h1>
          </div>
          <div class="ut-flex ut-flex-row ut-items-start ut-content-start">
              <div class=" ut-w-full md:ut-w-2/3 lg:ut-w-1/2 ut-m-0">
                  We are in the process of setting up your CRM,
                  don’t worry it will be done soon and when
                  it’s finished we’ll let you know.
              </div>
          </div>
      </div>

      <div v-show="!hasCRMIntegration || crmReconnectionRequired" class="section-to-connect">
        <div class="page-heading">
            <h1>Connect your CRM</h1>
        </div>
        <div class="ut-flex ut-flex-row ut-items-start ut-content-start">
          <div class="ut-m-0 ut-w-full">
            <p class="ut-my-4">
                Select your CRM from the dropdown below
            </p>

            <select-list class="ut-my-8"
                    :options="CRMList"
                    v-model="selectedCRM">
            </select-list>

            <div v-show="isOtherCRM" class="input-wrapper ut-mt-4 form-group">
                <label>Please Specify</label>
                <input v-model="otherCRMName"
                       v-on:keydown="validate()"
                       type="text"
                       name="other"/>
            </div>

            <div v-show="hasIntegration" class="form-group">
                <div class="input-wrapper ut-mt-4 ut-w-full">
                    <label>Username</label>
                    <input type="text"
                           v-model="loginDetail.username"
                           v-on:keydown="validate()"
                           name="username"/>
                </div>
                <div class="input-wrapper ut-mt-4 ut-w-full">
                    <label>Password</label>
                    <input type="password"
                           v-model="loginDetail.password"
                           v-on:keydown="validate()"
                           name="password"/>
                </div>
                <div v-show="requireOfficeIdToLogin" class="input-wrapper ut-mt-4 ut-w-full">
                    <label>Office Id</label>
                    <input type="text"
                           v-model="loginDetail.officeid"
                           v-on:keydown="validate()"
                           name="officeid"/>
                </div>
            </div>
            <div class="ut-my-4">
              <input type="checkbox"
                     name="is-authorised"
                     id="is-authorised"
                     v-model="isAuthorised"
                     v-on:change="validate()"
                     value="1">
              <label for="is-authorised" class="checkbox-text">
              I'm authorised to request information with this CRM
              </label>
            </div>

            <div class="ut-my-4 ut-h-20" v-show="isValidatingCredentials">
              <span class="ut-float-left"><loading-spinner /></span>
              <span class="validating-msg">Validating your login details... this might take a minute please be patient.</span>
            </div>

            <div class="ut-my-4" v-show="hasError">
              <ul class="ut-text-red-400"
                  v-bind:key="error"
                  v-for="error in errors">
                  <li>{{error}}</li>
              </ul>
            </div>

            <div class="ut-my-8">
              <button :disabled="disableSubmit"
                      v-on:click="connectCRM()"
                      class="btn btn-green ut-px-20 ut-py-4 ut-text-base">
                  Connect
              </button>
            </div>
          </div>
        </div>
      </div>

    </article>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SelectList from '@/components/Forms/SelectList.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'ProspectingPlugNPlay',
  components: {
    SelectList,
    LoadingSpinner
  },
  props: {
    preSelectedCRM: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      CRMList: [
        { value: null, text: 'Select your CRM', selected: !this.preSelectedCRM },
      ],
      selectedCRM: null,
      disableSubmit: false,
      isValidatingCredentials: false,
      isAuthorised: false,
      errors: [],
      otherCRMName: '',
      loginDetail: {
        username: '',
        password: '',
        officeid: '',
      },
      integrationAvailableCRM: [
        {id: 2, name: 'Box+Dice'},
        {id: 5, name: 'mydesktop'},
        {id: 7, name: 'rex'},
        {id: 9, name: 'lockedon'},
        {id: 10, name: 'harcourts'},
        {id: 11, name: 'irealty'},
        {id: 12, name: 'Aro CRM'},
        {id: 13, name: 'CoreWeb'},
        {id: 14, name: 'Infusionsoft'},
        {id: 16, name: 'eSales'}
      ],
      CRMLoginNeedsOfficeId: [
        {id: 12, name: 'Aro CRM'}
      ],
      CRMTokenRequiresManualInsert: [
        {id: 1, name: 'agentbox'},
        {id: 15, name: 'zenu'}
      ],
    };
  },
  mounted() {
    this.getCRMList();
    // check for crm integration as well
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
    }),
    ...mapGetters('userStore', [
      'hasCRMIntegration',
      'crmReconnectionRequired',
    ]),
    isOtherCRM() {
      return this.getCRMVal('other');
    },
    hasIntegration() {
      let crmName = this.integrationAvailableCRM.filter(crm => crm.id == this.selectedCRM)[0];
      
      return crmName? this.getCRMVal(crmName.name) : false;
    },
    requireOfficeIdToLogin() {
      let crmName = this.CRMLoginNeedsOfficeId.filter(crm => crm.id == this.selectedCRM)[0];
      
      return crmName? this.getCRMVal(crmName.name) : false;
    },
    requireManualTokenToImport() {
      let crmName = this.CRMTokenRequiresManualInsert.filter(crm => crm.id == this.selectedCRM)[0];
      return crmName? this.getCRMVal(crmName.name) : false;
    },

    
    hasError() {
      return this.errors.length;
    },
  },
  methods: {
    reset() {
      this.errors = [];
    },
    validate() {
      this.reset();
      if (!this.hasSelectedCRM()) {
        this.errors.push('Please select a CRM');
        return;
      }

      // need to click auth check box
      if (!this.isAuthorised) {
        this.errors.push('Please confirm you are authorised to request information from this CRM');
      }

      // check if other
      if (this.isOtherCRM) {
        // need to provide crm name
        if (this.otherCRMName === null || this.otherCRMName === '') {
          this.errors.push('Please enter the name of your CRM');
        }
        return;
      }

      if (this.hasIntegration) {
        // need to provide crm name
        if (this.loginDetail.username === ''
            || this.loginDetail.username === null
            || this.loginDetail.password === ''
            || this.loginDetail.password === null) {
          this.errors.push('Please enter your login details');
        }
        if (this.requireOfficeIdToLogin) {
          // need to provide crm name
          if (this.loginDetail.officeid === ''
              || this.loginDetail.officeid === null) {
            this.errors.push('Please enter your office id');
          }
        }
      }
    },
    hasSelectedCRM() {
      return this.selectedCRM.trim() !== '';
    },
    connectCRM() {
      // validate form
      this.validate();

      if (this.hasError) {
        return;
      }

      const crmId = this.hasSelectedCRM() ? this.selectedCRM : null;

      // disable submit button here
      this.disableSubmit = true;
      this.isValidatingCredentials = true;

      //set active flag to 1 if no manual token insert required
      const data = {
        enabled: this.requireManualTokenToImport ? 0 : 1,
        crmprovidertypeid: crmId,
        crmproviderconnectiondata: null,
        agentid: this.agent.id,
        agency: this.agent.agencyid,
        prospectorserviceid: this.userProspectorStatus.prospectorServiceId,
      };

      if (this.hasIntegration) {
        console.log('hasIntegration');
       
        console.log(this.selectedCRM);
        // validate login
        // get token
        const authData = {
          agentid: this.agent.id,
          agencyid: this.agent.agencyid,
          crmusername: this.loginDetail.username,
          crmpassword: this.loginDetail.password,
          crmtypeid: crmId,
          officeid: this.loginDetail.officeid,
        };
        this.$apiServices.pp.crmProvider.authenticate(authData)
          .then((crmProviderData) => {
            console.log(crmProviderData);
            if(this.requireOfficeIdToLogin){
              crmProviderData = crmProviderData? (crmProviderData.office = this.loginDetail.officeid) : {"office": this.loginDetail.officeid};
            }

            data.crmproviderconnectiondata = JSON.stringify(crmProviderData);
            this.isValidatingCredentials = false;

            // was this a re-connection?
            if (this.crmReconnectionRequired) {
              // update crm
              console.log('update');
              this.updateCRMForAgent(true);
            } else {
              console.log('new');
              this.addCRMForAgent(data);
            }
          }, (err) => {
            this.disableSubmit = false;
            this.isValidatingCredentials = false;
            this.errors.push('Login details are incorrect');
            console.error(err);
          });
        return;
      }


      // check if selected CRM is other
      if (this.isOtherCRM) {
        // save to db with other crm data
        data.crmproviderconnectiondata = JSON.stringify({
          crm: this.otherCRMName,
        });
      }

      // send data to api
      this.addCRMForAgent(data);
    },

    addCRMForAgent(data) {
      this.$apiServices.pp.crmProvider.create(data)
        .then(() => {
          // show thank you form
          this.$store.dispatch('userStore/loadUserProspectorStatus', this.user.key);
        }, (err) => {
          this.disableSubmit = false;
          this.errors.push('Error adding CRM, please try again.');
          console.error(err);
        });
    },
    updateCRMForAgent(status) {
      const payload = {
        authStatus: status,
      };

      this.$apiServices.pp.crmProvider.updateAuthStatus(this.userProspectorStatus.crmProvider.id, payload)
        .then(() => {
          console.log('here');
          // show thank you form
          this.$store.dispatch('userStore/loadUserProspectorStatus', this.user.key);
          this.$modal.hide('prospecting-reconnect-crm-modal');
        }, (err) => {
          this.disableSubmit = false;
          this.errors.push('Error re-connecting CRM, please try again.');
          console.error(err);
        });
    },
    getCRMList() {
      this.$apiServices.pp.crmProvider.getTypes()
        .then((crmProviderTypes) => {
          if (crmProviderTypes) {
            crmProviderTypes.forEach((CRM) => {
              this.CRMList.push({
                value: CRM.id, text: CRM.crmprovidertype, selected: false,
              });
            });
          }
        }, (err) => {
          console.error(err);
        });
    },
    getCRMVal(needle) {
      if (needle === null || needle === undefined) {
        throw 'Needle invalid';
      }

      const needleSanitized = needle.trim().toLowerCase();
      const val = this.CRMList.find(crm => crm.text.trim().toLowerCase() === needleSanitized);

      return val !== null
        && val !== undefined
        && this.selectedCRM === val.value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.custom {
    padding: 16px !important;
}

.validating-msg {
  line-height: 110px;
}
.input-wrapper {
    @apply ut-relative ut-text-left ut-ml-0;
    width: 400px;
    max-width: 100%;
}
</style>
